
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('backend/in_memory',["require", "exports", '../generic/key_value_filesystem', '../core/browserfs'], function(require, exports, kvfs, browserfs) {
    /**
    * A simple in-memory key-value store backed by a JavaScript object.
    */
    var InMemoryStore = (function () {
        function InMemoryStore() {
            this.store = {};
        }
        InMemoryStore.prototype.name = function () {
            return 'In-memory';
        };
        InMemoryStore.prototype.clear = function () {
            this.store = {};
        };

        InMemoryStore.prototype.beginTransaction = function (type) {
            return new kvfs.SimpleSyncRWTransaction(this);
        };

        InMemoryStore.prototype.get = function (key) {
            return this.store[key];
        };

        InMemoryStore.prototype.put = function (key, data, overwrite) {
            if (!overwrite && this.store.hasOwnProperty(key)) {
                return false;
            }
            this.store[key] = data;
            return true;
        };

        InMemoryStore.prototype.delete = function (key) {
            delete this.store[key];
        };
        return InMemoryStore;
    })();
    exports.InMemoryStore = InMemoryStore;

    /**
    * A simple in-memory file system backed by an InMemoryStore.
    */
    var InMemoryFileSystem = (function (_super) {
        __extends(InMemoryFileSystem, _super);
        function InMemoryFileSystem() {
            _super.call(this, { store: new InMemoryStore() });
        }
        return InMemoryFileSystem;
    })(kvfs.SyncKeyValueFileSystem);
    exports.InMemoryFileSystem = InMemoryFileSystem;

    browserfs.registerFileSystem('InMemory', InMemoryFileSystem);
});
//# sourceMappingURL=in_memory.js.map
;